import { createContext } from 'react';

import { DraggedFile } from './interfaces';

const FilesDragContext = createContext<DraggedFile>(null);

export default FilesDragContext;
